import { useTranslation } from "react-i18next";
import React from "react";
import {cn} from "../utils/style";
function Logo({className}) {
  const { t } = useTranslation();
  return <img className={cn(className, "h-10 w-auto")} src="/logo-z.svg" alt={t("Linkzdata")} />;
}
export default Logo;
